import type { PreBookingShipment } from "@freightsimple/generated-dashboard-openapi-client/models/PreBookingShipment";
import type { QuoteScreenShipmentGroup } from "../Headers/DashboardQuoteScreenGroupHeader";

export function dashboardGenerateQuoteScreenShipmentGroupKey(
  shipment: PreBookingShipment,
): QuoteScreenShipmentGroup {
  return {
    pickupCity: shipment.pickupLocation.address.city,
    pickupStateOrProvinceCode:
      shipment.pickupLocation.address.stateOrProvinceCode,
    deliveryCity: shipment.deliveryLocation.address.city,
    deliveryStateOrProvinceCode:
      shipment.deliveryLocation.address.stateOrProvinceCode,
  };
}
